import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';

import {
	wrapperStyles,
	labelStyles,
	inputStyles,
	errorStyles,
	optionalEditStyles,
	labelEditStyles,
	inputEditStyles,
	inputSizeEditStyles,
	inputSizeStyles,
	inputPadding,
} from '@/css/shared/inputs.css';
import { fluidBorderRadius, fontStyle } from '@/css/resources/mixins.css';

const getStyles = (formStyles) =>
	css(wrapperStyles(formStyles), inputSizeStyles(), {
		'&.supt-inputField--error': {
			'.supt-inputSelect__input': {
				borderColor: formStyles.error?.color,
			},
		},

		'.supt-inputSelect__label': labelStyles(formStyles),
		'.supt-inputSelect__input': cssObj(inputStyles(formStyles), {
			background: 'none !important',
		}),
		'.supt-inputSelect__input:not(textarea)': {
			padding: '0 !important', // Only target frontend element
		},
		'.supt-inputSelect__error': errorStyles(formStyles),
		'.supt-inputSelect__control': cssObj(
			inputPadding(formStyles),
			fluidBorderRadius(formStyles?.input?.border?.radius),
			{
				border: 'none',
				background: formStyles?.input?.backgroundColor,
				minHeight: 'auto',
				position: 'static',

				'&--is-focused': {
					border: 'none',
					boxShadow: 'none',
				},
			}
		),
		'.supt-inputSelect__placeholder': {
			color: `${formStyles?.input?.color}66`,
			margin: 0,
		},
		'.supt-inputSelect__value-container': {
			padding: 0,
		},
		'.supt-inputSelect__input-container': {
			margin: 0,
			padding: 0,
		},
		'.supt-inputSelect__indicators': {
			position: 'absolute',
			top: '50%',
			right: '15px',
			transform: 'translateY(-50%)',

			'svg path': {
				stroke: formStyles?.label?.color,
			},
		},
		'.supt-inputSelect__dropdown-indicator': {
			padding: 0,
		},
		'.supt-inputSelect__menu': {
			width: 'calc(100% - 24px)',
			zIndex: 2,
		},
		'.supt-inputSelect__option': fontStyle({
			fontSize: [13, 16],
			lineHeight: [19, 24],
		}),
		'.supt-inputSelect__option--is-selected': {
			color: 'inherit',
			backgroundColor: formStyles?.select?.selected?.backgroundColor,
		},
		'.supt-inputSelect__option--is-focused, .supt-inputSelect__option:focus':
			{
				backgroundColor: formStyles?.select?.focused?.backgroundColor,
			},
		'.supt-inputSelect__single-value': {
			color: formStyles?.input?.color,
		},
	});

// edit
const getEditStyles = (formStyles) =>
	css({
		'.supt-inputSelect__inner': {
			position: 'relative',
		},
		'.supt-inputSelect__optional': optionalEditStyles(formStyles),
		'.supt-inputSelect__input': inputEditStyles(formStyles),
		'.supt-inputSelect__label': labelEditStyles(),
	});

const getEditGlobalStyles = () =>
	cssObj({
		'.wp-block[data-type="supt/input-select"]': inputSizeEditStyles(),
	});

export { getStyles, getEditStyles, getEditGlobalStyles };
